<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)"
>
</app-cardholder-details>

<form
  name="notesForm"
  novalidate
  *ngIf="hasEntitlements('CARDHOLDERS_NOTES_CREATE')"
  [formGroup]="notesForm"
>
  <div class="card card-nc">
    <div class="card-heading ">
      <span class="icon-NC_createnotes"></span>
      <span class="panelHeaderHeading"> CREATE NOTES </span>&nbsp;&nbsp;
      <span class="pull-right save-panel">
        <button
          [disabled]="save_a_btn"
          class="btn btn-nc save-panel-btn"
          (click)="saveNote()"
        >
          SAVE <i [ngClass]="note_btn_spinner"> </i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3 zeroPadding">
          <label for="note_cat" class="col-md-12 control-label labelCommon">
            Category
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              formControlName="note_cat"
              id="note_cat"
              (change)="dropdownChange()"
            >
              <option value="" [disabled]="disabled" selected
                >Please Select...</option
              >
              <option
                *ngFor="let note_cat of categories"
                value="{{ note_cat.name }}"
                >{{ note_cat.name }}</option
              >
            </select>
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !notesForm.get('note_cat').valid &&
                notesForm.get('note_cat').touched
              "
            >
              <span *ngIf="notesForm.get('note_cat').errors?.required">
                Required
              </span>
            </span>
          </div>
        </div>
        <div class="form-group col-md-3 zeroPadding">
          <label for="note_type" class="col-md-12 control-label labelCommon">
            Type
          </label>
          <div class="col-md-12">
            <select
              class="form-control input-sm"
              formControlName="note_type"
              id="note_type"
            >
              <option value="" selected>Please Select...</option>
              <option *ngFor="let noteType of noteTypes" [value]="noteType">{{
                noteType
              }}</option>
            </select>
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !notesForm.get('note_type').valid &&
                notesForm.get('note_type').touched
              "
            >
              <span *ngIf="notesForm.get('note_type').errors?.required">
                Required
              </span>
            </span>
          </div>
        </div>
        <div class="form-group col-md-3 zeroPadding">
          <label for="note_case" class="col-md-12 control-label labelCommon">
            Case ID
          </label>
          <div class="col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="note_case"
              formControlName="note_case"
              maxlength="13"
            />
          </div>
        </div>
      </div>
      <div class="row zeroPadding">
        <label
          for="note_detail"
          class="col-md-11 control-label zeroPadding labelCommon"
        >
          Description
        </label>
        <label class="col-md-1 control-label zeroPadding labelCommon">
          ({{ note_detail_size }}/1000)
        </label>
        <div
          class="form-group col-md-12 zeroPadding"
          style="padding-bottom:15px;"
        >
          <textarea
            style="resize:none;"
            placeholder="Text Here for Notes"
            formControlName="note_detail"
            id="note_detail"
            class="form-control rounded-0"
            rows="7"
            maxlength="1000"
            required
          >
          </textarea>
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !notesForm.get('note_detail').valid &&
              notesForm.get('note_detail').touched
            "
          >
            <span *ngIf="notesForm.get('note_detail').errors?.required">
              Required
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="card card-nc" *ngIf="hasEntitlements('CARDHOLDERS_NOTES_LIST')">
  <div class="card-heading ">
    <i class="fa fa-keyboard-o"></i>
    <span class="panelHeaderHeading"> NOTES </span>
  </div>
  <div class="card-body" style="padding: 0;">
    <div class="row notesRow" *ngFor="let note of notes">
      <div
        class="col-md-12 row zeroPadding text-nowrap"
        style="padding-top: 5px;"
      >
        <div class="col-md-2 zeroPadding">
          <div class="col-md-12 labelCommon">Date Time</div>
          <div class="col-md-12 staticText1">
            {{ note.dateCreated | date: 'mediumDate' }}
          </div>
        </div>
        <div class="col-md-2 zeroPadding">
          <div class="col-md-12 labelCommon">Name</div>
          <div class="col-md-12 staticText1">{{ note.creater }}</div>
        </div>
        <div class="col-md-2 zeroPadding">
          <div class="col-md-12 labelCommon">Case Id</div>
          <div class="col-md-12 staticText1">{{ note.caseId }}</div>
        </div>
        <div class="col-md-2 zeroPadding">
          <div class="col-md-12 labelCommon">Category</div>
          <div class="col-md-12 staticText1">{{ note.name }}</div>
        </div>
        <div class="col-md-2 zeroPadding">
          <div class="col-md-12 labelCommon">Type</div>
          <div class="col-md-12 staticText1">{{ note.type }}</div>
        </div>
        <div
          class="col-md-12 noteDetailText wrapword"
          style="padding-top: 8px;padding-bottom: 8px;"
        >
          {{ note.detail }}
        </div>
      </div>
    </div>
    <div class="row searchResultsRow" *ngIf="notes.length == 0">
      No account notes found.
    </div>
  </div>
</div>
